export default __webpack_public_path__ + "static/img-finish-products-8a142d4dc94f3f82961e2787bc6007c4.webp";